<template>
  <section>
    <search-product />
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <brands />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <categories />
      </b-col>
    </b-row>
    <list-product />
  </section>
</template>

<script>
import SearchProduct from './SearchProduct.vue'
import ListProduct from './ListProduct.vue'
import Brands from './Brands.vue'
import Categories from './Categories.vue'

export default {
  name: 'SearchProductHome',
  components: {
    SearchProduct,
    Brands,
    Categories,
    ListProduct,
  },
  created() {
    // this.$store.dispatch('store/stores')
  },
}
</script>
